import { useState, useEffect, useCallback } from 'react';
import { EPOCH_END_EVENT, EPOCH_START_EVENT } from '@/constants';

const INTERVAL_TIME = 1000;
const DAY_PER_SECONDS = 86400;
const HOUR_PER_SECONDS = 3600;
const MINUTE_PER_SECONDS = 60;

const getEpochTime = () => Math.floor(new Date().getTime() / 1000);

function useDateCountdown() {
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const [timeHasRunOut, setTimeHasRunOut] = useState(false);
  const [isEventOver, setIsEventOver] = useState(0);

  const calculateTimeLeft = useCallback(() => {
    const currentEpoch = getEpochTime();
    const TIME_LEFT = EPOCH_START_EVENT - currentEpoch;

    if (TIME_LEFT < 0) {
      setIsEventOver((prev) => {
        const newValue = currentEpoch > EPOCH_END_EVENT;
        if (prev !== newValue) {
          return newValue;
        }
        return prev;
      });
      setTimeHasRunOut((prev) => {
        if (!prev) {
          return true;
        }
        return prev;
      });
      return;
    }

    const daysLeft = Math.floor(TIME_LEFT / DAY_PER_SECONDS);
    const hoursLeft = Math.floor((TIME_LEFT % DAY_PER_SECONDS) / HOUR_PER_SECONDS);
    const minutesLeft = Math.floor(((TIME_LEFT % DAY_PER_SECONDS) % HOUR_PER_SECONDS) / MINUTE_PER_SECONDS);
    const secondsLeft = Math.floor(((TIME_LEFT % DAY_PER_SECONDS) % HOUR_PER_SECONDS) % MINUTE_PER_SECONDS);

    // Chỉ update state khi giá trị thay đổi để tránh re-render không cần thiết
    setDays((prev) => (prev !== daysLeft ? daysLeft : prev));
    setHours((prev) => (prev !== hoursLeft ? hoursLeft : prev));
    setMinutes((prev) => (prev !== minutesLeft ? minutesLeft : prev));
    setSeconds((prev) => (prev !== secondsLeft ? secondsLeft : prev));
  }, []);

  useEffect(() => {
    if (timeHasRunOut) {
      return;
    }

    // Tính toán ngay lần đầu
    calculateTimeLeft();

    const interval = setInterval(() => {
      calculateTimeLeft();
    }, INTERVAL_TIME);

    return () => clearInterval(interval);
  }, [calculateTimeLeft, timeHasRunOut]);

  return { days, hours, minutes, seconds, timeHasRunOut, isEventOver };
}

export default useDateCountdown;
